<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import OptionsMenu from './OptionsMenu.vue';
import AgentDetails from './AgentDetails.vue';
import NotificationBell from './NotificationBell.vue';
import wootConstants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';
import { useTrack } from 'dashboard/composables';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    OptionsMenu,
    AgentDetails,
    NotificationBell,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  emits: ['toggleAccounts', 'openNotificationPanel', 'openKeyShortcutModal'],
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
      showOptionsMenu: false,
      aiAdminBackgroundUrl: window?.chatwootConfig?.viteAppAIAdminBackgroundUrl,
    };
  },
  methods: {
    frontendURL,
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggleAccounts');
    },
    toggleSupportChatWindow() {
      window.$chatwoot.toggle();
    },
    openNotificationPanel() {
      useTrack(ACCOUNT_EVENTS.OPENED_NOTIFICATIONS);
      this.$emit('openNotificationPanel');
    },
    async handleAdminRedirect() {
    try {
      // // 请求获取 token
      // const response = await fetch('/api/get-token', {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      // });
      // if (!response.ok) {
      //   throw new Error('Failed to fetch token');
      // }

      // const { token } = await response.json();

      // // 跳转到新域名，携带 token 作为查询参数
      const targetURL = this.aiAdminBackgroundUrl
      // console.log("A 页面 origin:", window.location.origin);
      // const targetURL = `https://example.com?token=${encodeURIComponent(token)}`;
      const newWindow = window.open(targetURL, '_blank');
      // setTimeout(() => {
      //   console.info("===========12313==========")
      //   newWindow.postMessage(
      //           { action: "ping", content: "你好，页面 B！" },
      //           "http://localhost:3001/signup" // 确保目标 origin 是正确的
      //       );
      // }, 1000 * 10)
      // 定时检查目标页面是否加载完成
      // 定时器：定期检查目标窗口是否加载完成

//       const checkWindowLoaded = setInterval(() => {
//         console.info(newWindow, "===========12313==========")
//   try {
//     // 检查目标窗口是否仍然存在（未被关闭）
//     if (!newWindow || newWindow.closed) {
//       console.error("目标窗口已被关闭");
//       clearInterval(checkWindowLoaded);
//       return;
//     }

//     // 发送消息
//     newWindow.postMessage({ deviceToken: "exampleDeviceToken" }, targetURL);
//     console.log("消息已发送到目标窗口");

//     // 如果发送成功，停止轮询
//     clearInterval(checkWindowLoaded);
//   } catch (error) {
//     // 如果抛出错误，可能是窗口尚未加载，继续轮询
//     console.warn("消息发送失败，目标窗口可能尚未加载完成，重试中...");
//   }
// }, 100);

    } catch (error) {
      console.error('Error fetching token or redirecting:', error);
    }
  },
  },
};
</script>

<template>
  <div
    class="flex flex-col justify-between w-16 h-full bg-white border-r dark:bg-slate-900 border-slate-50 dark:border-slate-800/50 rtl:border-l rtl:border-r-0"
  >
    <div class="flex flex-col items-center">
      <Logo
        :source="logoSource"
        :name="installationName"
        :account-id="accountId"
        class="m-4 mb-10"
      />
      <PrimaryNavItem
        v-for="menuItem in menuItems"
        :id="menuItem.key"
        :key="menuItem.toState"
        :icon="menuItem.icon"
        :name="menuItem.label"
        :to="menuItem.toState"
        :is-child-menu-active="menuItem.key === activeMenuItem"
      />
    </div>
    <div class="flex flex-col items-center justify-end pb-6">
      <!-- <a
        v-if="!isACustomBrandedInstance"
        v-tooltip.right="$t(`SIDEBAR.DOCS`)"
        :href="helpDocsURL"
        class="relative flex items-center justify-center w-10 h-10 my-2 rounded-lg text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        <fluent-icon icon="book-open-globe" />
        <span class="sr-only">{{ $t(`SIDEBAR.DOCS`) }}</span>
      </a> -->
      <!-- <a
        v-tooltip.right="$t(`SIDEBAR.ADMIN`)"
        @click="handleAdminRedirect"
        class="relative flex items-center justify-center w-10 h-10 my-2 rounded-lg text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600"
        rel="noopener noreferrer nofollow"
      >
        <fluent-icon icon="automation" />
        <span class="sr-only">{{ $t(`SIDEBAR.ADMIN`) }}</span>
      </a> -->
      <NotificationBell @open-notification-panel="openNotificationPanel" />
      <AgentDetails @toggle-menu="toggleOptions" />
      <OptionsMenu
        :show="showOptionsMenu"
        @toggle-accounts="toggleAccountModal"
        @show-support-chat-window="toggleSupportChatWindow"
        @open-key-shortcut-modal="$emit('openKeyShortcutModal')"
        @close="toggleOptions"
      />
    </div>
  </div>
</template>
